var _line, _line2, _rect, _line3, _line4, _line5, _line6, _line7, _line8, _rect2, _line9, _line10, _line11, _rect3, _rect4, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevenueLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 306,
    viewBox: "0 0 572 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.32112,
    y1: 250.679,
    x2: 8.67888,
    y2: 250.679,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.32112,
    y1: 208.679,
    x2: 8.67888,
    y2: 208.679,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 169,
    width: 8,
    height: 0,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3.32112,
    y1: 125.679,
    x2: 8.67888,
    y2: 125.679,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.32112,
    y1: 83.6789,
    x2: 8.67888,
    y2: 83.6789,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 3.32112,
    y1: 44.6789,
    x2: 8.67888,
    y2: 44.6789,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 466.679,
    y1: 302.679,
    x2: 466.679,
    y2: 298.321,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 550.679,
    y1: 302.679,
    x2: 550.679,
    y2: 298.321,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 382.679,
    y1: 302.679,
    x2: 382.679,
    y2: 298.321,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 304,
    width: 7,
    height: 0,
    transform: "rotate(-90 300 304)",
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 214.679,
    y1: 302.679,
    x2: 214.679,
    y2: 298.321,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 130.679,
    y1: 302.679,
    x2: 130.679,
    y2: 298.321,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 46.6789,
    y1: 302.679,
    x2: 46.6789,
    y2: 298.321,
    stroke: "#ECECEE",
    strokeWidth: 2.64224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 56,
    width: 0,
    height: 222,
    stroke: "#ECECEE",
    strokeWidth: 1.32112
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 563,
    y: 278,
    width: 0,
    height: 528,
    transform: "rotate(90 563 278)",
    stroke: "#ECECEE",
    strokeWidth: 1.32112
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.647 213.312C83.435 219.499 50 197.366 50 197.366V264H564.78V86.1397C543.447 58.4025 514.796 18.3709 500.611 32.7745C424.991 109.562 405.584 -12.8628 361.336 6.00587C316.19 25.2573 313.419 115.597 264.824 117.646C242.323 118.594 248.136 188.663 225.65 189.962C202.69 191.288 179.151 130.558 157.412 138.532C134.172 147.056 126.175 205.735 102.647 213.312Z",
    fill: "url(#paint0_linear_1647_471)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53 200.655C53 200.655 85.1249 217.482 104.194 210.15C127.547 201.17 135.59 148.088 158.657 137.985C180.234 128.534 201.223 192.002 224.012 190.43C246.331 188.891 242.937 114.355 265.271 113.231C313.506 110.803 317.541 27.4272 362.352 4.61054C406.272 -17.7526 421.014 113.23 499.625 31.4162C514.484 15.9518 541.552 68.0354 563 75.8898",
    stroke: "#6D7D8B",
    strokeOpacity: 0.3,
    strokeWidth: 2.75988,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1647_471",
    x1: 332.663,
    y1: 14.4284,
    x2: 332.663,
    y2: 259.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138542,
    stopColor: "#F0F2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F2F3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueLoader);
export default __webpack_public_path__ + "static/media/revenueLoader.b2d1eb7b.svg";
export { ForwardRef as ReactComponent };